module.exports = import("/react-tree-select/assets/remoteEntry.js");